'use strict';

/**
 * API Token status for list/display.
 * - ACTIVE: not revoked and not expired
 * - REVOKED: revoked_at is set
 * - EXPIRED: expires_at < now and not revoked (excluded from list per product requirement)
 */
export const ApiTokenStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  REVOKED: 'REVOKED',
  EXPIRED: 'EXPIRED',
});
